<div *ngIf="hasProviderPacket">
  <app-icon [iconName]="iconName" (click)="downloadProviderPacket()"></app-icon>
  <span class="packet-type">{{ providerPacketTemplate }}</span>
</div>
